import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@uoa/auth';
import { isPhoneNumberFeatureEnabled } from './core/phone-number-feature';
import { APP_ROUTE_PATHS } from './core/route-paths';

const phoneNumbersRoutes: Routes = isPhoneNumberFeatureEnabled
  ? [
      {
        path: APP_ROUTE_PATHS.phoneNumbers,
        loadChildren: () => import('./pages/phone-numbers/phone-numbers.module').then((m) => m.PhoneNumbersModule),
        canActivate: [AuthGuard],
      },
    ]
  : [];

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: APP_ROUTE_PATHS.prompts,
  },
  {
    path: APP_ROUTE_PATHS.prompts,
    // loadChildren: () => import('./pages/wallboard/wallboards.module').then((m) => m.WallboardsModule),
    loadChildren: () => import('./pages/self-service/self-service.module').then((m) => m.SelfServiceModule),
    // component: SelfServiceContainerComponent,
    // data: { applyPreload: true },
    canActivate: [AuthGuard],
  },
  ...phoneNumbersRoutes,
  {
    path: `${APP_ROUTE_PATHS.error}/:errorCode`,
    loadChildren: () => import('./error-routing/error-routing.module').then((m) => m.ErrorRoutingModule),
  },

  // Below all TBA
  {
    path: APP_ROUTE_PATHS.wallboards,
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/wallboard/wallboards.module').then((m) => m.WallboardsModule),
  },
  // {
  //   path: 'self-service',
  //   canActivate: [AuthGuard],
  //   component: SelfServiceContainerComponent,
  //   loadChildren: () => import('./pages/self-service/self-service.module').then((m) => m.SelfServiceModule),
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
